/** A built-in opportunity card field the user can show or hide. */
export enum OpportunityCardField {
  QUOTE_NUMBERS = "quoteNumbers",
  COMPANY = "company",
  SALES_REP = "salesRep",
  ESTIMATORS = "estimators",
  CREATED_AT = "createdAt",
  AMOUNT = "amount",
  PROBABILITY = "probability",
  PENDING_ACTION = "pendingAction",
}

/** The built-in card fields, in the order the card renders them. */
export const OPPORTUNITY_CARD_FIELDS: {
  id: OpportunityCardField;
  label: string;
}[] = [
  { id: OpportunityCardField.QUOTE_NUMBERS, label: "Quote number" },
  { id: OpportunityCardField.COMPANY, label: "Company" },
  { id: OpportunityCardField.SALES_REP, label: "Sales rep" },
  { id: OpportunityCardField.ESTIMATORS, label: "Estimators" },
  { id: OpportunityCardField.CREATED_AT, label: "Created" },
  { id: OpportunityCardField.AMOUNT, label: "Amount" },
  { id: OpportunityCardField.PROBABILITY, label: "Probability" },
  { id: OpportunityCardField.PENDING_ACTION, label: "Awaiting action" },
];

/** The fields shown until the user picks their own set: what the card showed before it was configurable. */
export const DEFAULT_CARD_FIELD_IDS: string[] = OPPORTUNITY_CARD_FIELDS.map(
  (field) => field.id,
);

/** Card field id for a quote custom field, prefixed so it never collides with an opportunity custom field id. */
export function quoteCustomFieldId(fieldName: string): string {
  return `quoteCustom:${fieldName}`;
}

/** Card field id for a company custom field, prefixed so it never collides with other custom field ids. */
export function companyCustomFieldId(fieldName: string): string {
  return `companyCustom:${fieldName}`;
}
